// @flow @jsx h

import { Component, h } from 'preact'
import { Video, VideoPlayer } from '@nrk/dh-feature-components'

import '@nrk/dh-feature-components/dist/module/video/VideoPlayer/index.css'
import '@nrk/dh-feature-components/dist/module/video/VideoPlayer/Scrubber.css'
import '@nrk/dh-feature-components/dist/module/video/VideoPlayer/ToggleMuteButton.css'
import '@nrk/dh-feature-components/dist/module/video/VideoPlayer/TogglePlayButton.css'

import styles from './index.css'

type VideoSource = {
  type: 'video/mp4' | 'video/webm',
  src: string
}

type Props = {
  poster: string,
  sources: VideoSource[],
  playing: boolean,
  textTracks: any[]
}

type State = {
  paused: boolean,
  muted: boolean
}

export class VideoContent extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      paused: false,
      muted: true
    }
  }

  handleUserToggleMute = () => {
    this.setState({ muted: !this.state.muted })
  }

  handleUserTogglePlay = () => {
    this.setState({ paused: !this.state.paused })
  }

  handleVideoError = () => {
    this.setState({ paused: true })
  }

  render () {
    const { sources, poster, textTracks } = this.props
    const { muted } = this.state

    const playing = !!this.props.playing && !this.state.paused

    const video = <Video
      preload='none'
      sources={sources}
      poster={poster}
      playing={playing}
      muted={muted}
      textTracks={textTracks}
      onError={this.handleVideoError}
    />

    return (
      <VideoPlayer
        video={video}
        playing={playing}
        muted={muted}
        className={styles.videoContent}
        onUserTogglePlay={this.handleUserTogglePlay}
        onUserToggleMute={this.handleUserToggleMute}
      />
    )
  }
}
